import { Box, Flex } from '@chakra-ui/react';
import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { ChevronDownIcon, ChevronUpIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { TextMedium, TextRegular } from 'UiKit/typography';
import LivestreamDatetime from 'View/host-presence-content/components/livestream-datetime';
import violationCodeToText from 'View/host-presence-content/helpers/violationCodeToText';
import { dropdownAnimation } from 'View/host-presence-content/helpers/dropdownAnimation';

import styles from './styles.module.css';

const LivestreamRecordItem = ({ label, livestreamData }) => {
  const { t } = useTranslation('host-presence');
  const [isOpen, setIsOpen] = useState(false);
  const startDateTime = livestreamData?.clockIn?.time || null;
  const endDateTime = livestreamData?.clockOut?.time || null;
  const clockInNote = livestreamData?.clockIn?.note || '-';
  const clockOutNote = livestreamData?.clockOut?.note || '-';
  const transformedViolations = livestreamData?.violations?.map((violation) => violationCodeToText(violation, t));
  return (
    <Box>
      <Flex onClick={() => setIsOpen(!isOpen)}>
        <LivestreamDatetime label={label} startDateTime={startDateTime} endDateTime={endDateTime} violations={transformedViolations} />
        <Condition statement={isOpen} fallback={<ChevronDownIcon size={20} />}>
          <ChevronUpIcon size={20} />
        </Condition>
      </Flex>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div {...dropdownAnimation}>
            <Box className={styles['dropdown__section']}>
              <Flex gap="6px">
                <Flex flex={1} gap="16px">
                  <Flex width="45%" flexDir="column">
                    <TextRegular fontSize="var(--font-caption1)">{t('page.notes')}</TextRegular>
                    <TextMedium fontSize="var(--font-body3)">{clockInNote || '-'}</TextMedium>
                  </Flex>
                  <Flex width="calc(55% + 30px)" flexDir="column">
                    <TextRegular fontSize="var(--font-caption1)">{t('page.notes')}</TextRegular>
                    <TextMedium fontSize="var(--font-body3)">{clockOutNote || '-'}</TextMedium>
                  </Flex>
                </Flex>
              </Flex>
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default LivestreamRecordItem;
